import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TenantLocale } from './tenantlocale.model';

const tenantLocaleApiBaseUrl = '/api/v3/tenant-locales';

@Injectable({ providedIn: 'root' })
export class TenantLocalesBackend {
  constructor(private http: HttpClient) {}

  public getTenantLocales() {
    return this.http.get<{ tenantLocales: TenantLocale[] }>(
      tenantLocaleApiBaseUrl,
    );
  }
}
